import { QuestionDto } from 'libs/features/shared/src/lib/dtos/question.dto';

type HandleRevalidate = ({
  guid,
  value,
}: {
  guid: QuestionDto['guid'];
  value: QuestionDto['answer']['value'];
}) => {
  guid: QuestionDto['guid'];
  value: QuestionDto['answer']['value'];
};
export const handleRevalidate: HandleRevalidate = ({ guid, value }) => ({
  guid,
  value,
});
